import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import companyPaymentService from '../../../services/companyPaymentService'
import { CompanyPayment } from '@leadgen/models/client'
import selectors from './selectors'
import { RootState } from '../../types/RootState'

class CompanyPaymentsActions {
  loadCompanyPaymentsFresh = createAsyncThunk(
    'companyPayments/loadCompanyPaymentsFresh',
    async ({ companyId }: { companyId: string }, { dispatch }) => {
      const response = await companyPaymentService.fetchCompanyPaymentsFirstPage({
        companyId,
        onCompanyPaymentAdded: companyPayment => {
          dispatch(this.addCompanyPayment(companyPayment))
        },
        onCompanyPaymentUpdated: companyPayment => {
          dispatch(this.updateCompanyPayment(companyPayment))
        },
      })
      return response
    },
  )
  loadCompanyPaymentsNext = createAsyncThunk<
    Awaited<ReturnType<typeof companyPaymentService.fetchCompanyPaymentsNextPage>>,
    { companyId: string },
    { state: RootState }
  >('companyPayments/loadCompanyPaymentsNext', async ({ companyId }, { dispatch, getState }) => {
    const latestTimestamp = selectors.getPaginationTimestamp(getState())
    if (!latestTimestamp) {
      throw new Error('Invalid pagination timestamp')
    }
    const response = await companyPaymentService.fetchCompanyPaymentsNextPage({
      companyId,
      startAfter: latestTimestamp,
      onCompanyPaymentUpdated: companyPayment => {
        dispatch(this.updateCompanyPayment(companyPayment))
      },
    })
    return response
  })
  addCompanyPayment = createAction(
    'companyPayments/addCompanyPayment',
    (companyPayment: CompanyPayment) => ({
      payload: companyPayment,
    }),
  )
  updateCompanyPayment = createAction(
    'companyPayments/updateCompanyPayment',
    (companyPayment: CompanyPayment) => ({
      payload: companyPayment,
    }),
  )
}

export default new CompanyPaymentsActions()
